import React from 'react';
import { ComponentDoc, CodeExample } from '@cimpress/react-components';
import DemoCode from '!raw-loader!./demo.jsx';
import Demo from './demo.jsx';

const DemoDocs = () => {
  const aProp = {
    name: 'aProp',
    type: 'string',
    default: '',
    description: 'If this were a prop, you could describe it here.',
  };

  return (
    <ComponentDoc name="My Demo Component" propInfos={[aProp]}>
      <Demo />
      <CodeExample code={DemoCode} initialOpen={false} />
    </ComponentDoc>
  );
};

export default DemoDocs;
